/** returns exchange table list
@return { Array }
*/
export const getExchangeTableList = state => state.exchangeTableList

/** returns exchange table with value list
@return { Array }
*/
export const getExchangeTableWithValue = state => state.exchangeTableWithValue

/** returns last update date
@return { String }
*/
export const getLastUpdateDate = state => state.lastUpdateDate
